import React from 'react';

const Console = React.lazy(() => import(/* webpackChunkName: "console" */ 'src/components/pages/console'));

const PlanManager = React.lazy(() => import(/* webpackChunkName: "planManager" */ 'src/components/pages/planManager'));
const ShopifyCharge = React.lazy(() => import(/* webpackChunkName: "shopifyCharge" */ 'src/components/pages/shopifyCharge'));
const WorldMap = React.lazy(() => import(/* webpackChunkName: "worldMap" */ 'src/components/pages/worldMap'));
const MarketplaceThemes = React.lazy(() => import(/* webpackChunkName: "marketplaceThemes" */ 'src/components/pages/marketplaceThemes'));

const administratorRoutes = [
    { url: '/console', component: Console },
    { url: '/plan-manager/:subpage', component: PlanManager },
    { url: '/plan-manager', component: PlanManager },
    { url: '/shopify-charge', component: ShopifyCharge },
    { url: '/world-map', component: WorldMap },
    { url: '/marketplace-themes', component: MarketplaceThemes }
];

export default administratorRoutes;
